import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { objetivosPorPGD } from "../../Redux/evaluaciones";
import moment from "moment";

const useObjetivosPGD = (token, id) => {
    const dispatch = useDispatch();

    const [openModalModo, setOpenModalModo] = useState("");
    const [openModalNuevoObjetivo, setOpenModalNuevoObjetivo] = useState(false);
    const [openModalCancelObjetivo, setOpenModalCancelObjetivo] = useState(false);

    const [getPgdObjetivos, setGetPgdObjetivos] = useState(false);
    const [objetivosPGD, setObjetivosPGD] = useState([]);
    const [targetObjetivo, setTargetObjetivo] = useState({})
    const [targetObjetivoCancel, setTargetObjetivoCancel] = useState({})
    const getPgdObjetivosSelector = useSelector((store) => store.evaluaciones.getPgdObjetivos);
    const objetivosPGDSelector = useSelector((store) => store.evaluaciones.objetivosPGD);
    useEffect(() => {
        if (token && id) {
            dispatch(objetivosPorPGD(token, id));
        }
    }, [token, id]);

    useEffect(() => {
       if (objetivosPGDSelector?.length > 0 && getPgdObjetivosSelector) {
            const array = [];
            objetivosPGDSelector.forEach((items) => {
                let item = {
                    id: items["new_objetivodeevaluacionid"],
                    objetivo: items["new_name"],
                    fechaDeCarga:
                        items["createdon@OData.Community.Display.V1.FormattedValue"],
                    fechaDeCumplimiento: items.new_fechadecumplimiento ? moment(items["new_fechadecumplimiento@OData.Community.Display.V1.FormattedValue"], "DD/MM/YY").format("YYYY-MM-DD") : null,
                    peso: items.new_ponderacionlider,
                    competencia: {
                        value: items._new_competencia_value,
                        label: items["_new_competencia_value@OData.Community.Display.V1.FormattedValue"],
                    },
                    competencia2: {
                        value: items._new_competencia2_value,
                        label: items["_new_competencia2_value@OData.Community.Display.V1.FormattedValue"],
                    },
                    indicador: items.new_resultadoclave,
                    indicador2: items.new_indicador2,
                    indicador3: items.new_indicador3,
                    indicador4: items.new_indicador4,
                    indicador5: items.new_indicador5,
                    competenciaPrimaria: items["_new_competencia_value@OData.Community.Display.V1.FormattedValue"],
                    competenciaSecundaria: items["_new_competencia2_value@OData.Community.Display.V1.FormattedValue"],
                    statusSelect: {
                        value: items.new_status,
                        label: items["new_status@OData.Community.Display.V1.FormattedValue"],
                    },
                    motivoCancelar: {
                        value: items.new_motivodecancelaciondeobjetivo,
                        label: items["new_motivodecancelaciondeobjetivo@OData.Community.Display.V1.FormattedValue"],
                    },
                    porcentajeAvance: items["new_deavance"],
                    estado: items["statuscode@OData.Community.Display.V1.FormattedValue"],
                    estadoSelect: {
                        value: items.statuscode,
                        label: items["statuscode@OData.Community.Display.V1.FormattedValue"]
                    },
                    estadoFinal: {
                        value: items.new_estadofinal,
                        label: items["new_estadofinal@OData.Community.Display.V1.FormattedValue"]
                    }
                };
                array.push(item);
            });
            setObjetivosPGD(array);
            setGetPgdObjetivos(getPgdObjetivosSelector);
        } else if (objetivosPGDSelector?.length === 0 && getPgdObjetivosSelector) {
            setGetPgdObjetivos(getPgdObjetivosSelector);
        }
    }, [objetivosPGDSelector, getPgdObjetivosSelector])

    const handleObjetivo = (id, data, index) => {
        if (id) {
          setOpenModalModo("editar");
          setOpenModalNuevoObjetivo(true)
          setTargetObjetivo(data);
        }
        else if (index!= null && index != undefined) {
            data.index = index;
          setOpenModalModo("editar");
          setOpenModalNuevoObjetivo(true);
          setTargetObjetivo(data);
        }
      };
    const handleCancelObjetivo = (id, data, index) => {
        if (id) {
            setOpenModalCancelObjetivo(true)
            setTargetObjetivoCancel(data)
        }
        else if (index!= null && index != undefined) {
            data.index = index;
            setOpenModalCancelObjetivo(true)
            setTargetObjetivoCancel(data)
        }
    };

    return {getPgdObjetivos, objetivosPGD, targetObjetivo, setGetPgdObjetivos, setObjetivosPGD, setTargetObjetivo, targetObjetivoCancel, setTargetObjetivoCancel, handleObjetivo, handleCancelObjetivo, openModalModo, setOpenModalModo, openModalNuevoObjetivo, setOpenModalNuevoObjetivo, openModalCancelObjetivo, setOpenModalCancelObjetivo}
}

export default useObjetivosPGD